import { render, staticRenderFns } from "./ItemLinked.vue?vue&type=template&id=0ed91350"
import script from "./ItemLinked.vue?vue&type=script&lang=js"
export * from "./ItemLinked.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports